import { render } from "./ReferralInfo.vue?vue&type=template&id=71d267d4&scoped=true&lang=pug"
import script from "./ReferralInfo.vue?vue&type=script&lang=js"
export * from "./ReferralInfo.vue?vue&type=script&lang=js"

import "./ReferralInfo.vue?vue&type=style&index=0&id=71d267d4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d267d4"]])

export default __exports__